import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { SlArrowDown, SlArrowUp } from "react-icons/sl";
import { AiOutlineClose } from "react-icons/ai";
import { SelectPrintContainer } from "../styled/scheduler";

const SelectPrint = ({ setOpenPrint }) => {
  const { mySchedSet, isDarkMode } = useSelector((state) => state?.scheduler);

  const [printSet, setPrintSet] = useState({ personalYn: false });
  const [isOpen, setIsOpen] = useState({
    companyYnList: true,
    groupYnList: true,
  });

  useEffect(() => {
    setPrintSet({
      personalYn: false,
      ...["companyYnList", "groupYnList"].reduce((acc, key) => {
        acc[key] = mySchedSet[key].map((item) => ({
          ...item,
          check: false,
        }));
        return acc;
      }, {}),
    });
  }, [mySchedSet]);

  const handleClose = () => setOpenPrint(false);

  const handleCheckboxChange = (e) => {
    const { name, id, checked } = e.target;
    setPrintSet((prev) => {
      if (name === "personalYn") {
        return { ...prev, personalYn: checked };
      }
      return {
        ...prev,
        [name]: prev[name].map((item) =>
          String(item.orgNo) === id.split("-")[2] ? { ...item, check: checked } : item,
        ),
      };
    });
  };

  const toggleOpen = (category) => setIsOpen((prev) => ({ ...prev, [category]: !prev[category] }));

  const handleSelectAll = (name) => {
    setPrintSet((prev) => {
      const allChecked = prev[name].every((item) => item.check);
      return {
        ...prev,
        [name]: prev[name].map((item) => ({
          ...item,
          check: !allChecked,
        })),
      };
    });
  };

  const handleConfirm = () => {
    console.log(printSet);
    alert("준비중입니다.");
  };

  return (
    <SelectPrintContainer
      onClick={(e) => e.target === e.currentTarget && handleClose()}
      className={isDarkMode}>
      <div className="content">
        <div className="label">
          <span>인쇄할 일정의 유형을 선택해주세요.</span>
          <button onClick={handleClose}>
            <AiOutlineClose />
          </button>
        </div>
        <ul>
          <li className="personal">
            <label htmlFor="print-personalYn">
              <input
                type="checkbox"
                checked={printSet.personalYn}
                name="personalYn"
                id="print-personalYn"
                onChange={handleCheckboxChange}
              />
              개인
            </label>
          </li>

          {["companyYnList", "groupYnList"].map(
            (listName) =>
              printSet[listName]?.length > 0 && (
                <li key={listName} className={listName}>
                  <label htmlFor={`print-${listName}-all`}>
                    <input
                      type="checkbox"
                      checked={printSet[listName].every((item) => item.check)}
                      onChange={() => handleSelectAll(listName)}
                      id={`print-${listName}-all`}
                    />
                    {listName === "companyYnList" ? "전체 업무" : "전체 모임"}
                  </label>
                  <div className="more">
                    <button type="button" onClick={() => toggleOpen(listName)}>
                      {listName === "companyYnList" ? "업무 상세보기" : "모임 상세보기"}
                      <span>{isOpen[listName] ? <SlArrowUp /> : <SlArrowDown />}</span>
                    </button>
                    <ul className={isOpen[listName] ? "active" : ""}>
                      {printSet[listName].map((item) => (
                        <li key={item.orgNo}>
                          <label htmlFor={`print-${listName}-${item.orgNo}`}>
                            <input
                              type="checkbox"
                              id={`print-${listName}-${item.orgNo}`}
                              name={listName}
                              checked={item.check}
                              onChange={handleCheckboxChange}
                            />
                            {item.orgNm}
                          </label>
                        </li>
                      ))}
                    </ul>
                  </div>
                </li>
              ),
          )}
        </ul>
        <button type="button" onClick={handleConfirm}>
          선택완료
        </button>
      </div>
    </SelectPrintContainer>
  );
};

export default SelectPrint;
